import React, { Component } from 'react';

type Contact = {
    name: String,
    id?: String,
    email: String
}

type ContactListProps = {
    contacts: Array<Contact>
}

class ContactList extends Component<ContactListProps> {

    constructor(props: ContactListProps)
    {
        super(props);
    }

    render() {

        const contacts = this.props.contacts;

        return (
            <div className='ContactList'>
                <h2>Участники</h2>
                {
                    contacts.map( (c, index) => 
                    <a className='ContactItem' href={`mailto:${c.email}`} key={index}>
                        @{c.name}
                    </a>)
                }
            </div>
        );
    }
}

export default ContactList